module.exports = __webpack_public_path__ + "static/media/youtube-rond.d5583488.png";